import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import axios from "axios";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";

export const editorProjectServices = {
  addNewEditorProject,
  updateProjectData,
  updateFileFolderData,
  addNewDataLibrary,
  getDatasetByLibraryId,
  getStudyDatasetByUniqueId,
  uploadFileinProjectDataLibrary,
  duplicateDataEDCEditorFileAndDataset,
  addNewEditorProjectFileFolder,
  addNewProgrammingEnvironment,
  softDeleteRestoreProjectData,
  getEditorProjectData,
  getDeletedEditorProjectData,
  getProjectCodeVersionHistory,

  addUpdateProjectCodeData,
  getSingleProjectDetails,
  runGasProcedureCode,
  getProjectInformation,
  getOnlyPackageList,
  getSinglePackageDetailsData,
  getSinglePackageStatementData,
  getProjectDataForDashboard,
  renameLocalFile,
  duplicateLocalFile,
  deleteLocalFile,
  readSystemFileAsJSON,
  uploadLocalSystemFiles,
  checkInCheckoutProjectCode,
  getProjectDetailsByVersion,
  lockUnlockFolders
};


// Upload and Save Package Library Data
async function uploadFileinProjectDataLibrary(formData) {
  try {
    const response = await axios.post(
      `${config.API_URL_USER_ONBOARDING}uploadFileinProjectDataLibrary`,
      formData,
      {
        headers: {
          Authorization: headers.authorization,
        },
      }
    );
    const data = response?.data;
    handleResponse(data);
    return data;
  } catch (error) {
    const errData = error.response?.data || { message: error.message };
    handleResponse(errData);
    return errData;
  }
}

//Upload Local System File
async function uploadLocalSystemFiles(formData) {
  try {
    const response = await axios.post(
      `${config.API_URL_USER_ONBOARDING}uploadLocalSystemFiles`,
      formData,
      {
        headers: {
          Authorization: headers.authorization,
        },
      }
    );
    const data = response?.data;
    handleResponse(data);
    return data;
  } catch (error) {
    const errData = error.response?.data || { message: error.message };
    handleResponse(errData);
    return errData;
  }
}

async function lockUnlockFolders(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}lockUnlockFolders`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function duplicateDataEDCEditorFileAndDataset(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}duplicateDataEDCEditorFileAndDataset`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function addNewEditorProject(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEditorProject`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function updateProjectData(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateProjectData`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function updateFileFolderData(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateFileFolderData`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}
async function addNewDataLibrary(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewDataLibrary`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}
async function addNewEditorProjectFileFolder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEditorProjectFileFolder`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}
async function addNewProgrammingEnvironment(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewProgrammingEnvironment`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}
async function softDeleteRestoreProjectData(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreProjectData`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getEditorProjectData(status, studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getEditorProjectData/${status}/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getDeletedEditorProjectData(type, parentId, studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getDeletedEditorProjectData/${type}/${parentId}/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getProjectCodeVersionHistory(studyId, projectId, uniqueId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProjectCodeVersionHistory/${studyId}/${projectId}/${uniqueId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getProjectDetailsByVersion(studyId, projectId, uniqueId, version) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProjectDetailsByVersion/${studyId}/${projectId}/${uniqueId}/${version}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getDatasetByLibraryId(libraryId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getDatasetByLibraryId/${libraryId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStudyDatasetByUniqueId(libraryId, studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyDatasetByUniqueId/${libraryId}/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function addUpdateProjectCodeData(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdateProjectCodeData`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getSingleProjectDetails(studyId, projectId, commonId, type) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSingleProjectDetails/${studyId}/${projectId}/${commonId}/${type}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function runGasProcedureCode(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}runGasProcedureCode`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  return data;
}

async function getProjectInformation(studyId, projectId, uniqueId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProjectInformation/${studyId}/${projectId}/${uniqueId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getProjectDataForDashboard(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProjectDataForDashboard/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getOnlyPackageList() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getOnlyPackageList`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Single Package Statement Data
async function getSinglePackageStatementData(packageId, version) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSinglePackageStatementData/${packageId}/${version}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Single Package Details Data
async function getSinglePackageDetailsData(type, packageId, version) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSinglePackageDetailsData/${type}/${packageId}/${version}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Rename Local File
async function renameLocalFile(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}renameLocalFile`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  return data;
}

// Duplicate Local File
async function duplicateLocalFile(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}duplicateLocalFile`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  return data;
}

// Delete Local File
async function deleteLocalFile(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteLocalFile`,
    headersWithAuth("DELETE", datas, headers)
  );
  const data = await response.json();
  return data;
}

// Read Local File
async function readSystemFileAsJSON(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}readSystemFileAsJSON`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  return data;
}

// CheckIn and Checkout Project
async function checkInCheckoutProjectCode(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}checkInCheckoutProjectCode`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  return data;
}